import fetchJsonp from 'fetch-jsonp';
import { createAction } from 'redux-actions';

export default function ({ endpoint, types }) {
  return async (dispatch) => {
    const [PENDING, SUCCESS, ERROR] = types;
    const pending = createAction(PENDING);
    const success = createAction(SUCCESS);
    const error = createAction(ERROR);

    dispatch(pending());

    try {
      await fetchJsonp(endpoint)
        .then((response) => response.json())
        .then((body) => {
          dispatch(success(body));
        })
        .catch(() => {
          throw new Error('exception');
        });
    } catch (e) {
      dispatch(error(e));
    }
  };
}
